whenAvailable('$',function() {
$(function(){
    function navFeatures() {
        nav = $('#nav_features');

        if ( $(window).scrollTop() >= 200 && !nav.hasClass('active') ) {
            nav.addClass('active').stop().slideDown();
        } else if ( $(window).scrollTop() < 200 && nav.hasClass('active') ) {
            nav.removeClass('active').stop().slideUp();
        }
    }
    $(window).scroll(function(e){ navFeatures(); });
    navFeatures();

    $('body').on('click', '.catalog-mat-switch:not(.active)', function() {
        $('.catalog-mat').addClass('loading');

        var img = new Image(),
            sku = $(this).attr('data-sku'),
            _this = this;
        img.onerror = function() {
            $('.catalog-mat').removeClass('loading');
        };
        img.onload = function() {
            $('.catalog-mat-image img').attr('src', img.src);
            $('.catalog-mat').removeClass('loading');
            $('.catalog-mat-switch').removeClass('active');
            $(_this).addClass('active');
        }
        const variantName = sku?.split("-").pop()?.toUpperCase();
        img.src = 'https://images.secretlab.co/theme/common/desk_mat_' + variantName + '.jpg';
    });
});
});
